<div class="login-container">
  <div class="login-card">
    <h1>Welcome to PivotQuote</h1>

    <button class="okta-login-button" (click)="login()" [disabled]="isLoading">
      <span *ngIf="!isLoading">Sign in with Okta</span>
      <span *ngIf="isLoading">Redirecting...</span>
    </button>

    <div class="help-text">
      <p>
        First time logging in? Check your email for an activation link from
        Okta.
      </p>
      <p>
        Need help? Contact
        <a href="mailto:dfsitsupport&#64;fnbo.com">dfsitsupport&#64;fnbo.com</a>
      </p>
    </div>

    <div class="register-link">
      <a routerLink="/register">New dealer? Register here</a>
    </div>
  </div>
</div>
